import { useMemo, useCallback } from 'react';
import { usePlayerMaxTimeShift, usePlayerActions } from '@dtvgo/player-context';
import { useGetSync } from '@dtvgo/react-utils';
import './LiveInfoProvider/LiveInfoProvider.js';
import './LiveInfoProvider/contexts.js';
import { useLiveDuration, useLiveEdgeProgress, useLiveProgress } from './LiveInfoProvider/hooks.js';
import 'react/jsx-runtime';
import 'prop-types';

function useLiveProgressBarInfo() {
  const duration = useLiveDuration();
  const liveEdgeProgress = useLiveEdgeProgress();
  const progress = useLiveProgress();
  const maxTimeShift = usePlayerMaxTimeShift();
  const seekable = useMemo(() => ({
    start: Math.max(0, liveEdgeProgress + maxTimeShift),
    end: Math.min(duration, liveEdgeProgress)
  }), [duration, liveEdgeProgress, maxTimeShift]);
  const getLiveEdgeProgress = useGetSync(liveEdgeProgress);
  const { seek } = usePlayerActions();
  const handleSeek = useCallback((value) => {
    seek(value - getLiveEdgeProgress());
  }, [getLiveEdgeProgress, seek]);
  return {
    duration,
    progress,
    seekable,
    handleSeek
  };
}

export { useLiveProgressBarInfo };
//# sourceMappingURL=useLiveProgressBarInfo.js.map
